import React , {useState} from 'react'
import axios from 'axios'
import { Link,useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import {BsEyeSlash} from 'react-icons/bs'
import {BsEye} from 'react-icons/bs'
import { FiMail, FiLock } from 'react-icons/fi'
import Loader from '../components/Loader'
import AuthLayout from '../components/authLayout/AuthLayout'
const Login = ({route}) => {
  const navigate = useNavigate()
  const [showPassword,setShowPassword] = useState(false)
  const [email,setEmail] = useState('')
  const [password,setPassword] = useState('')
  const [loader, setLoader] = useState(false)
  const [check,setChecked] =  useState(false)
  const [challengeToken, setChallengeToken] = useState(null)
  const [twoFactorCode, setTwoFactorCode] = useState('')


  // sweet alert function
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })


  const login = async () => {
    try {
      setLoader(true);

      // Make a POST request using axios
      const request = await axios.post(
        `${route}/api/login`,
        {
          email,
          password,
          rememberme: check,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );


    // Destructure the response data
    const { status, token } = request.data;


    if (status === '2fa_required') {
      setChallengeToken(request.data.challengeToken);
    } else if (status === 'ok' && token) {
    //   // Save the token to localStorage
      localStorage.setItem('token', token);

      Toast.fire({
        icon: 'success',
        title: 'Signed in successfully',
      });

      // Navigate to the dashboard
      navigate('/dashboard');

    } else if (status === 400) {
      Toast.fire({
        icon: 'error',
        title: 'Error! Email not verified',
      });
    } else if (status === 401) {
      Toast.fire({
        icon: 'warning',
        title: 'Warning! Incorrect password',
      });
    } else {
      Toast.fire({
        icon: 'error',
        title: 'User does not exist',
      });
    }
  } catch (error) {
    console.error('Login error:', error);

    // Handle unexpected errors
    Toast.fire({
      icon: 'error',
      title: 'Something went wrong. Please try again.',
    });
  } finally {
    setLoader(false);
  }
};

  const verifyTwoFactor = async () => {
    try {
      setLoader(true);
      const { data } = await axios.post(`${route}/api/login/2fa`, { challengeToken, code: twoFactorCode });

      if (data.status === 'ok' && data.token) {
        localStorage.setItem('token', data.token);
        Toast.fire({ icon: 'success', title: 'Signed in successfully' });
        navigate('/dashboard');
      } else if (data.status === 401) {
        // challenge expired: send the user back to the password step
        setChallengeToken(null);
        setTwoFactorCode('');
        Toast.fire({ icon: 'warning', title: data.message });
      } else {
        Toast.fire({ icon: 'warning', title: data.message || 'Invalid authentication code' });
      }
    } catch (error) {
      Toast.fire({ icon: 'error', title: 'Something went wrong. Please try again.' });
    } finally {
      setLoader(false);
    }
  };

  if (challengeToken) {
    return (
      <AuthLayout
        heading="Two-factor authentication"
        subheading="Enter the 6-digit code from your authenticator app to finish signing in."
      >
        {loader && <Loader />}
        <form className="auth-form" onSubmit={(e) => { e.preventDefault(); verifyTwoFactor() }}>
          <div className="auth-field">
            <label htmlFor="twofactor_field">Authentication code</label>
            <input
              id="twofactor_field"
              className="auth-input code"
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              placeholder="000000"
              autoFocus
              required
              value={twoFactorCode}
              onChange={(e) => setTwoFactorCode(e.target.value.replace(/\D/g, ''))}
            />
          </div>
          <button type="submit" className="auth-submit">Verify and sign in</button>
          <p className="auth-switch">
            <button type="button" className="auth-link" onClick={() => { setChallengeToken(null); setTwoFactorCode('') }}>
              ← Back to sign in
            </button>
          </p>
        </form>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout heading="Welcome back">
      {loader && <Loader />}
      <form className="auth-form" onSubmit={(e) => { e.preventDefault(); login() }}>
        <div className="auth-field">
          <label htmlFor="email_field">Email</label>
          <div className="auth-input-wrap">
            <span className="auth-input-icon"><FiMail size={17} /></span>
            <input
              id="email_field"
              className="auth-input"
              type="email"
              autoComplete="email"
              placeholder="name@mail.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value.trim().toLocaleLowerCase())}
            />
          </div>
        </div>

        <div className="auth-field">
          <label htmlFor="password_field">Password</label>
          <div className="auth-input-wrap">
            <span className="auth-input-icon"><FiLock size={17} /></span>
            <input
              id="password_field"
              className="auth-input has-toggle"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder="Enter your password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value.trim())}
            />
            <button type="button" className="auth-eye" onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}>
              {showPassword ? <BsEye size={17} /> : <BsEyeSlash size={17} />}
            </button>
          </div>
        </div>

        <div className="auth-meta">
          <label className="auth-check">
            <input type="checkbox" checked={check} onChange={() => setChecked(!check)} />
            Remember me
          </label>
          <Link to="/passwordreset" className="auth-link">Forgot password?</Link>
        </div>

        <button type="submit" className="auth-submit">Sign in</button>

        <p className="auth-switch">
          Don't have an account? <Link to="/signup" className="auth-link">Create one</Link>
        </p>
        <p className="auth-legal">
          By signing in you agree to our <Link to="/privacy-policy">Terms &amp; Privacy Policy</Link>.
        </p>
      </form>
    </AuthLayout>
  )
}

export default Login
